var exports = {
  "q": "x61f99309--53354b--features",
  "N": "x61f99309--53354b--feature",
};

module.exports = exports;
